/**
 * ----------------------------------------
 *	Main JS file
 * ----------------------------------------
 */

import $ from 'jquery';
import 'what-input';
import 'tablesaw/dist/tablesaw.jquery';
// import slick from 'slick-carousel';
// import matchHeight from 'jquery-match-height';
import cookieBar from 'jquery.cookiebar';
import SVGInject from '@iconfu/svg-inject/dist/svg-inject';
import './lib/simolax';
import AOS from 'aos';
import objectFitImages from 'object-fit-images';
// import jscroll from 'jscroll';


// Foundation JS relies on a global varaible. In ES6, all imports are hoisted
// to the top of the file so if we used`import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
// require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces';


jQuery(document).ready(function($) {
  // Foundation init
  $(document).foundation();

  // tablesaw plugin init
  $(document).trigger('enhance.tablesaw');

  // SVGInject plugin init
  SVGInject(document.querySelectorAll("img.inject-svg"));

  // custom JS code here

	/**
	 * Cookie Notify (jquery.cookieBar plugin)
 	 */
  $('.cookie-message').cookieBar({
    closeButton: '.js-cookie-close'
  });

	/**
	 * Mobile menu hamburger button
 	 */
	(function(){
		const bodyScrollLock = require('body-scroll-lock');
		const disableBodyScroll = bodyScrollLock.disableBodyScroll;
		const enableBodyScroll = bodyScrollLock.enableBodyScroll;
		const targetElement = document.querySelector('body');

		// show the mobile menu
	  $('#mobile-menu-wrapper').on('on.zf.toggler', function() {
	    $('#mobile-menu-activator').addClass('active');
			$('#mobile-menu-wrapper').css('max-height', 'calc(100vh - ' + ( $('.header-main').outerHeight() - 1) + 'px)');
			disableBodyScroll(targetElement);
			$('<div class="main-nav-mobile__overlay"></div>').hide().appendTo('body').fadeIn(400);
			// $('#page-content').addClass('unselectable');
			// $('#page-content').attr('tabindex', '-1');
	  });

		// hide the mobile menu
	  $('#mobile-menu-wrapper').on('off.zf.toggler', function() {
	    $('#mobile-menu-activator').removeClass('active');
			$('#mobile-menu-wrapper').css('max-height', '');
			enableBodyScroll(targetElement);
			// $('#page-content').removeClass('unselectable');
			// $('#page-content').removeAttr('tabindex');
			$('.main-nav-mobile__overlay').fadeOut(200, function(){
				$(this).remove();
			});
	  });

		// on overlay trigger close button click
		$('body').on('click', '.main-nav-mobile__overlay', function(){
			$('#mobile-menu-activator').trigger('click');
		});

		// hide expanded mobile menu with esc key
		$(document).on('keyup', function(e){
			if (e.key === 'Escape') {
				$('#mobile-menu-activator').trigger('click');
			}
		});
	})();

	/**
	 * Sticky shrinked header
 	 */
	(function(){
		function stickyHeader() {
			var sticky = $('.header').not('.header--disable-shrinking'),
		      scroll = $(window).scrollTop();

		  if (scroll >= 50) {
				sticky.removeClass('header--top').addClass('header--sticky');
			} else {
				sticky.addClass('header--top').removeClass('header--sticky');
			}
		}

		stickyHeader();

		$(window).scroll(function(){
		  stickyHeader();
		});
	})();


	/**
	 * Simolax init - animate colourful boxes on scroll for HC templates (.cta-hc section)
	 */
	$(window).simolax();


	/**
	 * Animate on Scroll
	 */
	AOS.init({
		once: true
	});


	/**
	 * MatchHeight plugin
 	 */
  // $('.js-matchHeight').matchHeight();


	/**
	 * Homepage Slider
 	 */
	/*
  $('.slick-homepage').slick({
    arrows: false,
    dots: true,
    // autoplay: true,
    // autoplaySpeed: 5000,
    // responsive: [
    // 	{
    // 		breakpoint: 1300,
    // 		settings: {
    // 			arrows: false
    // 		}
    // 	}
    // ]
  });
	*/

  // Equal height of slides
	/*
  $('.slick-slider').on('setPosition', function() {
    $(this).find('.slick-slide').height('auto');
    $(this).find('.slick-slide .slide-content').height('auto');
    var slickTrack = $(this).find('.slick-track');
    var slickTrackHeight = $(slickTrack).height();
    $(this).find('.slick-slide').css('height', slickTrackHeight + 'px');
    $(this).find('.slick-slide .slide-content').css('height', slickTrackHeight + 'px');
  });
	*/

	// Sidebar menu hide 12th and next items
	if ( $('.js-collapsed-menu, [id^=menu-sidebar-]').find('li:gt(10)').length ) {
		$('.js-collapsed-menu, [id^=menu-sidebar-]')
	  .find('> li:gt(10)')
	  .hide()
	  .end()
	  .append(
	    $('<li class="menu-more"><button>Show more...</button></li>').click( function(){
	      $(this).siblings(':hidden').show().end().remove();
	    })
		);
	}

	// $(document).on('mouseenter', '.listing .listing__link', listingLinkHover);
	// $(document).on('mouseleave', '.listing .listing__link', listingLinkHover);
	//
	// function listingLinkHover( event ) {
	// 	console.log('listingLinkHover');
	// 	var id = $(this).attr('data-toggle');
	// 	if (event.type === 'mouseenter') {
	// 		$('#'+id).show();
	// 		$('#'+id).css('visibility', 'visible');
	// 	} else {
	// 		$('#'+id).hide();
	// 		$('#'+id).css('visibility', 'hidden');
	// 	}
	// }

	// $(document).on({
  //   mouseenter: function(e) {
	// 		console.log('in');
	// 		var target = e.target;
	// 		$(target).next().show();
  //   },
  //   mouseleave: function(e) {
	// 		console.log('out');
	// 		$('.listing__dropdown').hide();
  //   }
	// }, ".listing__link");

	// $('body').on('click', function(e){
	// 	var target = e.target;
	// 	if ( $(target).hasClass('listing__link') ) {
	// 		$(target).next().show();
	// 	} else {
	// 		$('.listing__dropdown').hide();
	// 	}
	// });

	$('#js-disclaimer-button').on('click', function(){
		$('#js-disclaimer-text').slideToggle();
	});


});
